import React from 'react';
import { IconProps } from '@chakra-ui/react';
import { LockIcon } from '@chakra-ui/icons';

export const Login: React.FC<IconProps> = props => {
  return <LockIcon {...props} />;
};
